import Api from "./api";

const LanguageService = {
  changeLanguage: (lng) => {
    return Api.callApi('/sessions/language', 'POST', {
      language: lng
    })
  }
};

export default LanguageService;
